import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AutocompleteCustomLogicDirective } from './autocomplete-custom-logic.directive';
import { AutofocusDirective } from './autofocus.directive';
import { ClickOutsideDirective } from './click-outside.directive';
import { CloseOverlayForActiveLinkDirective } from './close-overlay-for-active-link.directive';
import { CounterDirective } from './counter.directive';
import { DebounceDirective } from './debounce.directive';
import { DeferLoadDirective } from './defer-load.directive';
import { DisableControlDirective } from './disable-control.directive';
import { ExternalLinkDirective } from './external-link.directive';
import { HorizontalScrollDirective } from './horizontal-scroll.directive';
import { LinkToRouteDirective } from './link-to-route.directive';
import { LongPressDirective } from './long-press.directive';
import { NgxTelInputPlaceholderDirective } from './ngx-tel-input-placeholder.directive';
import { NumberDirective } from './numbers-only.directive';
import { PasswordDirective } from './password.directive';
import { RemovableSearchInputDirective } from './removable-search-input.directive';
import { RequiredControlDirective } from './required-control.directive';
import { RequiredMarkerDirective } from './required-marker.directive';
import { StickyHeaderDirective } from './sticky-header.directive';
import { StopPropagationDirective } from './stop-propagation.directive';
import { TabsStateDirective } from './tabs-state.directive';
import { TrimTextInputDirective } from './trim-text-input.directive';
import { PhonePrefixDirective } from '$shared/directives/phone-prefix.directive';
import { AddDirective } from './add.directive';
import { TimeFormatDirective } from '$shared/directives/time-format.directive';
import { BelarusPhoneNumberDirective } from './belarus-phone-number.directive';
import { BarcodeDirective } from './barcode.directive';
import { NotEqualDirective } from './not-equal.directive';

@NgModule({
  declarations: [
    AutofocusDirective,
    DeferLoadDirective,
    LongPressDirective,
    NumberDirective,
    StickyHeaderDirective,
    PasswordDirective,
    CounterDirective,
    StopPropagationDirective,
    DebounceDirective,
    ExternalLinkDirective,
    DisableControlDirective,
    HorizontalScrollDirective,
    LinkToRouteDirective,
    NgxTelInputPlaceholderDirective,
    RequiredControlDirective,
    AutocompleteCustomLogicDirective,
    CloseOverlayForActiveLinkDirective,
    RequiredMarkerDirective,
    TrimTextInputDirective,
    ClickOutsideDirective,
    RemovableSearchInputDirective,
    TabsStateDirective,
    PhonePrefixDirective,
    AddDirective,
    TimeFormatDirective,
    BelarusPhoneNumberDirective,
    BarcodeDirective,
    NotEqualDirective,
  ],
  imports: [CommonModule, RouterModule],
  exports: [
    AutofocusDirective,
    DeferLoadDirective,
    LongPressDirective,
    NumberDirective,
    StickyHeaderDirective,
    PasswordDirective,
    CounterDirective,
    StopPropagationDirective,
    DebounceDirective,
    ExternalLinkDirective,
    DisableControlDirective,
    AutocompleteCustomLogicDirective,
    RemovableSearchInputDirective,
    HorizontalScrollDirective,
    LinkToRouteDirective,
    NgxTelInputPlaceholderDirective,
    RequiredControlDirective,
    CloseOverlayForActiveLinkDirective,
    RequiredMarkerDirective,
    TrimTextInputDirective,
    TabsStateDirective,
    ClickOutsideDirective,
    PhonePrefixDirective,
    AddDirective,
    TimeFormatDirective,
    BelarusPhoneNumberDirective,
    BarcodeDirective,
    NotEqualDirective,
  ],
})
export class DirectivesModule {}
